import React from 'react'
import { TtTrayHandout, TtButton } from '@23/react'
import { FormattedMessage } from 'react-intl'

import { TrayCardHandout } from '../../../../firebase/model/tray-cards/types/handout-model'
import {
  setActiveCard,
  useTrayCard,
  useTrayCardState,
} from '../../../../firebase/hooks/useTray'
import {
  useShareAttachment,
  useUnshareAttachment,
} from '../hooks/use-attachments'
import { PropsWithTrayItemChildren } from '../TrayItem'

interface HandoutCardProps {
  id: string
}

const HandoutCard = ({
  id,
  children,
}: PropsWithTrayItemChildren<HandoutCardProps>) => {
  const card = useTrayCard(id) as TrayCardHandout
  const cardState = useTrayCardState(id)
  const { mutate: share, isLoading: isStartLoading } = useShareAttachment()
  const { mutate: unshare, isLoading: isStopLoading } = useUnshareAttachment()

  if (card.type !== 'handout') return null

  return (
    <TtTrayHandout
      filename={card.filename}
      filesize={card.fileSize}
      selected={cardState === 'active'}
      disabled={cardState === 'done'}
      onTt-click={(event) => {
        if (event.target === event.currentTarget) {
          setActiveCard(card.id)
        }
      }}
    >
      {card.hidden && (
        <TtButton
          color="secondary"
          size="small"
          pill
          loading={isStartLoading}
          onClick={() => share(card.filename)}
        >
          <FormattedMessage defaultMessage="Share" />
        </TtButton>
      )}
      {!card.hidden && (
        <TtButton
          color="secondary"
          variant="outline"
          size="small"
          pill
          loading={isStopLoading}
          onClick={() => unshare(card.filename)}
        >
          <FormattedMessage defaultMessage="Stop sharing" />
        </TtButton>
      )}
      {children?.()}
    </TtTrayHandout>
  )
}

export default HandoutCard
